import React, { useState } from "react";
import { useSelector } from "react-redux";
import { CustomTab } from "../../../../components";
import styles from "../Create.module.css";
import { FaClipboardList } from "react-icons/fa";
import SecondaryAdmissionList from "./SecondaryAdmissionList";
import HigherSecondaryAdmissionList from "./HigherSecondaryAdmissionList";

const AdmissionListTabs = () => {
  const { translations } = useSelector((state) => state.language);
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  const tabs = [
    {
      label: translations?.labels?.secondaryVItoIX,
      content: <SecondaryAdmissionList />,
    },
    {
      label: translations?.labels?.higherSecondaryXI,
      content: <HigherSecondaryAdmissionList />,
    },
  ];

  return (
    <div className="admission-tabs-container">
      <div className={styles.container}>
        {/* Header */}
        <div className={styles.header}>
          <div className={styles.headerIcon}>
            <FaClipboardList />
          </div>
          <h1 className={styles.headerTitle}>
            {translations?.labels?.admissionApplicationList ||
              "Admission Application List"}
          </h1>
        </div>
        <CustomTab
          tabs={tabs}
          defaultActiveTab={0}
          onTabChange={handleTabChange}
        />
      </div>
    </div>
  );
};

export default AdmissionListTabs;
